var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"featureComingSoon",attrs:{"id":"feature-coming-soon","ok-only":true,"title":"Feature coming soon!"}},[_vm._v("\n  Feature coming soon!\n")])}
var staticRenderFns = []
export { render, staticRenderFns }